import { useState, FormEvent } from "react";
import { useAuth } from "./AuthContext";

export default function Login() {
  const { login, register, isLoading, error } = useAuth();
  const [mode, setMode] = useState<"login" | "register">("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [localError, setLocalError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setLocalError(null);

    if (mode === "register") {
      if (password !== passwordConfirm) {
        setLocalError("Passwörter stimmen nicht überein");
        return;
      }
      try {
        await register(username, password);
      } catch {
        // Fehler steckt bereits in `error` aus dem Context
      }
      return;
    }

    try {
      await login(username, password);
    } catch {
      // siehe oben
    }
  }

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>{mode === "login" ? "Anmeldung" : "Registrieren"}</h2>
        <label>
          Benutzername
          <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required />
        </label>
        <label>
          Passwort
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={mode === "login" ? "current-password" : "new-password"}
            required
          />
        </label>
        {mode === "register" && (
          <label>
            Passwort bestätigen
            <input
              type="password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              autoComplete="new-password"
              required
            />
          </label>
        )}
        {(localError || error) && <p className="login-error">{localError ?? error}</p>}
        <button type="submit" disabled={isLoading}>
          {isLoading ? (mode === "login" ? "Anmelden..." : "Registrieren...") : mode === "login" ? "Anmelden" : "Registrieren"}
        </button>

        <p style={{ marginTop: 12, fontSize: 14 }}>
          {mode === "login" ? (
            <>Noch keinen Account? <button type="button" className="link-button" onClick={() => setMode("register")}>Registrieren</button></>
          ) : (
            <>Bereits registriert? <button type="button" className="link-button" onClick={() => setMode("login")}>Zur Anmeldung</button></>
          )}
        </p>
      </form>
    </div>
  );
}